// Hook: GET /company/departments?location_id=X - lista dzialow

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import { IDepartment } from 'api/types/company';

export interface IRequest {
  location_id?: number;
}

export interface IResponse {
  items: IDepartment[];
  total?: number;
}

const getCompanyDepartments = (params?: IRequest): Promise<IResponse> =>
  axios.get('/company/departments', { params });

export const useGetCompanyDepartments = (
  params?: IRequest,
  options?: UseQueryOptions<IResponse, IError>
) =>
  useQuery<IResponse, IError>(
    ['company', 'departments', params?.location_id ?? 'all'],
    () => getCompanyDepartments(params),
    options
  );
